import { Card, CardContent, CardHeader, CardMedia, Grid, Typography } from '@mui/material';
import { Product } from '@thro-types/leihbar';

import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { ConditionalLink } from 'app/components';
import { LabeledInput } from 'app/components/RichList/items/CompanyItem/components/LabeledInput';
import ErrorLoadingImage from 'assets/errorLoadingImage.png';
import { translations } from 'locales/i18n';

import './ProductCard.scss';

interface Props {
  product: Product;
  isPreview?: boolean;
  className?: string;
  footer?: ReactNode;
  canceled?: boolean;
}

export const ProductCard = ({ product, isPreview = false, className, footer, canceled }: Props) => {
  const { t } = useTranslation();

  return (
    <Card
      raised
      sx={{ margin: '0 1.5em 1em 1.5em' }}
      className={className}
      content={t(translations.common.canceled()).toUpperCase()}
    >
      <ConditionalLink to={`/leihbar/product/${product.id}`} condition={!isPreview}>
        <CardMedia
          component={'img'}
          sx={{
            padding: '1em 1em 0 1em',
            height: '18em',
            objectFit: 'contain',
            ...(canceled && { position: 'relative', opacity: 0.4 })
          }}
          image={`${import.meta.env.VITE_S3_IMAGE_PROXY}/${product.image}` || ''}
          onError={e => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = ErrorLoadingImage;
          }}
        />
        <CardHeader
          title={
            <Typography fontSize={'1.5rem'} style={{ wordBreak: 'break-word' }}>
              {product.name}
            </Typography>
          }
        />
        <CardContent>
          <Grid container justifyContent={'space-between'}>
            <Grid item xs={6}>
              <LabeledInput label={t(translations.pages.leihbar.product.location())}>
                {product.location?.name}
              </LabeledInput>
            </Grid>
          </Grid>
          {footer}
        </CardContent>
      </ConditionalLink>
    </Card>
  );
};
